export class Pass{
    constructor(
        //public _id: string,
        public claveactual: string,
        public clavenueva: string,
        public claveconfirmacion: string,

    ){}
}